import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTrailerFuelings from './ReportTrailerFuelings'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportTrailerFuelings} />
    </Switch>
)

export default Components
